import { initializeApp } from 'firebase/app'
import { useRoute } from "vue-router"

initializeApp({
  apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
  authDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.VUE_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.VUE_APP_FIREBASE_APP_ID
})

const route = useRoute()

export let globalProperties = {}

import(/* webpackChunkName: "createApp" */ './createApp').then(createApp => {
  createApp.createApp()
})

